




























































import { Component, Vue, Prop } from "vue-property-decorator";
import AccessLogTable from "./AccessLogTable.vue";
import { AccessLogUserModel } from "../models";

@Component({
  components: { AccessLogTable },
})
export default class AccessLogUserPanel extends Vue {
  @Prop({ required: true })
  value!: AccessLogUserModel;

  private t(key: string): string {
    return this.$t("invoices.panel." + key).toString();
  }
}
